import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from '@shared/models/constants/constants';
import { deeplinkRoute } from '@shared/modules/deeplinks/common/constants/deeplink-route';
import { isWebApp } from '@dta/shared/utils/common-utils';

@Pipe({
  name: 'replaceDeeplinks',
  standalone: false
})
export class ReplaceDeeplinksPipe implements PipeTransform {
  transform(content?: string): string {
    if (isWebApp() && content) {
      return content.replace(
        new RegExp(CONSTANTS.DEEPLINK_PREFIX, 'g'),
        `https://${window.location.host}/${deeplinkRoute}/`
      );
    }

    return content;
  }
}
